import httpClient from './_httpClient';

const getTemplatesByScopeAndType = (scopeId, type) => httpClient.get('/scopes/' + scopeId + '/email-template/' + type);
const setEmailTemplate = (scopeId, templateId, templateData) => httpClient.put('/scopes/' + scopeId + '/email-template/' + templateId, templateData);
const sendTestMail = (templateData, templateType,scopeId) => httpClient.post('/scopes/email-template/' + templateType + '/test/'+ scopeId, templateData);

export {
  getTemplatesByScopeAndType,
  setEmailTemplate,
  sendTestMail
}
